const isCordova = !!window.cordova;

export {
  // eslint-disable-next-line import/prefer-default-export
  isCordova,
};



// WEBPACK FOOTER //
// ./src/utils/index.js